import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import storage from "redux-persist/lib/storage";
import userReducer from './reducers/userReducer';
import subscriptionReducer from './reducers/subscriptionReducer';
import authReducer from './reducers/authReducer';
import serviceReducer from './reducers/serviceReducer';
import activityReducer from './reducers/activityReducer';

const rootReducer = combineReducers({
    user: userReducer, // Gestion des appels
    subscription: subscriptionReducer,
    auth: authReducer,
    service: serviceReducer,
    activity: activityReducer,

});

const persistConfig = {
    key: "root",
    storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});
const persistor = persistStore(store);
export {persistor}
